import { Navigate, Outlet, useLocation } from "react-router-dom";
import { useAuth } from "../authentication/AuthProvider";
import { routes } from "../routes/routes";
import { findCurrectPermission } from "../helpers/roles-and-permissions";
import { enums } from "../enums/Enums";

export function ExpensePurchaseOrderManageGuard() {
  let location = useLocation();
  const auth = useAuth();

  return auth?.user &&
    findCurrectPermission(enums.UserPermissionNames.EPO_Manage) ? (
    <Outlet />
  ) : (
    <Navigate
      to={routes?.unAuthorized.match}
      state={{ from: location }}
      replace
    />
  );
}

export function ExpensePurchaseOrderMPCEPOViewerGuard() {
  let location = useLocation();
  const auth = useAuth();

  return auth?.user &&
    findCurrectPermission(enums.UserPermissionNames.EPO_MPC_EPO_VIEWER) ? (
    <Outlet />
  ) : (
    <Navigate
      to={routes?.unAuthorized.match}
      state={{ from: location }}
      replace
    />
  );
}

export function ExpensePurchaseOrderMPCVoteGuard() {
  let location = useLocation();
  const auth = useAuth();

  return auth?.user &&
    findCurrectPermission(enums.UserPermissionNames.EPO_MPC_VOTE_FOR_EPO) ? (
    <Outlet />
  ) : (
    <Navigate
      to={routes?.unAuthorized.match}
      state={{ from: location }}
      replace
    />
  );
}
export function ExpensePurchaseOrderMyEPOGuard() {
  let location = useLocation();
  const auth = useAuth();

  return auth?.user &&
    findCurrectPermission(enums.UserPermissionNames.EPO_MY_EPOS) ? (
    <Outlet />
  ) : (
    <Navigate
      to={routes?.unAuthorized.match}
      state={{ from: location }}
      replace
    />
  );
}

export function ExpensePurchaseOrderSubordinatesGuard() {
  let location = useLocation();
  const auth = useAuth();

  return auth?.user &&
    findCurrectPermission(
      enums.UserPermissionNames.EPO_VIEW_MY_SUB_ORDINATES_EPO
    ) ? (
    <Outlet />
  ) : (
    <Navigate
      to={routes?.unAuthorized.match}
      state={{ from: location }}
      replace
    />
  );
}

export function ExpensePurchaseOrderApprovalGuard() {
  let location = useLocation();
  const auth = useAuth();

  return auth?.user &&
    findCurrectPermission(enums.UserPermissionNames.EPO_MY_APPROVAL_FOR_EPO) ? (
    <Outlet />
  ) : (
    <Navigate
      to={routes?.unAuthorized.match}
      state={{ from: location }}
      replace
    />
  );
}
